module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forum-search panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-full"
  }, [_c('div', {
    staticClass: "search-text-controls"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    ref: "searchInput",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search forum posts and threads"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.target.blur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.reloadResults()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), (_vm.hasSearchRestrictions()) ? _c('div', {
    staticClass: "search-restriction-warning"
  }, [_c('div', {
    attrs: {
      "title": "See advanced options"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.searchRestrictionWarning) + "\n                    ")]), _vm._v(" "), _c('button', {
    attrs: {
      "title": "Clear restrictions"
    },
    on: {
      "click": function($event) {
        _vm.clearSearchRestrictions()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "result-controls"
  }, [_c('TabSelect', {
    attrs: {
      "options": _vm.searchModeOptions
    },
    model: {
      value: (_vm.searchMode),
      callback: function($$v) {
        _vm.searchMode = $$v
      },
      expression: "searchMode"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sort-dropdown"
  }, [_c('div', [_vm._v("Sort by:")]), _vm._v(" "), _c('DropdownSelect', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingPosts),
      expression: "showingPosts"
    }],
    attrs: {
      "options": _vm.sortOptionsForPosts,
      "value": _vm.dropdownSortForPosts
    },
    on: {
      "input": function($event) {
        _vm.sortForPosts = $event
      }
    }
  }), _vm._v(" "), _c('DropdownSelect', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingThreads),
      expression: "showingThreads"
    }],
    attrs: {
      "options": _vm.sortOptionsForThreads,
      "value": _vm.dropdownSortForThreads
    },
    on: {
      "input": function($event) {
        _vm.sortForThreads = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingPosts),
      expression: "showingPosts"
    }]
  }, [_c('ForumPostResultList', {
    ref: "postList",
    attrs: {
      "posts": _vm.posts
    }
  }), _vm._v(" "), (_vm.showAfterPostsMessage) ? _c('div', {
    staticClass: "after-posts-msg"
  }, [_vm._v("\n                        That's all, folks!\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.loadingPosts) ? _c('Loader') : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingThreads),
      expression: "showingThreads"
    }]
  }, [_c('ForumThreadList', {
    ref: "threadList",
    attrs: {
      "sortable": true,
      "sortOrder": _vm.headerSortForThreads,
      "threads": _vm.threads
    },
    on: {
      "update:sort-order": function($event) {
        _vm.sortForThreads = $event
      }
    }
  }), _vm._v(" "), (_vm.showAfterThreadsMessage) ? _c('div', {
    staticClass: "after-threads-msg"
  }, [_vm._v("\n                        That's all, folks!\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.loadingThreads) ? _c('Loader') : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-none"
  }, [_c('ForumSearchAdvancedOptions', {
    attrs: {
      "allCategories": _vm.allCategories,
      "allTermTypes": _vm.allTermTypes,
      "allPaths": _vm.allPaths,
      "allAssignments": _vm.allAssignments,
      "selectedCategoryIds": _vm.filters_categoryIds,
      "selectedTermTypes": _vm.filters_termTypes,
      "selectedPathIds": _vm.filters_pathIds,
      "selectedAssignmentIds": _vm.filters_assignmentIds
    },
    on: {
      "update:selectedCategoryIds": function($event) {
        _vm.filters_categoryIds = $event
      },
      "update:selectedTermTypes": function($event) {
        _vm.filters_termTypes = $event
      },
      "update:selectedPathIds": function($event) {
        _vm.filters_pathIds = $event
      },
      "update:selectedAssignmentIds": function($event) {
        _vm.filters_assignmentIds = $event
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Forum Search")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e2be3f22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForumSearch.vue
// module id = 2140
// module chunks = 2